import border from '../../border';

const light = (params) => border.disabled.light(params);

export default light;
